import axios, { AxiosPromise } from 'axios';

export type IpifyDto = {
  ip: string;
}
export const fetchIpAddress = (): AxiosPromise<IpifyDto> => {
  return axios.get('https://api.ipify.org?format=json');
};
